/* Reviews Section - "Proof Before The Spec Sheet" */
(function () {
  function setupReviewsProof(root) {
    if (root.dataset.rpInited === '1') return;
    root.dataset.rpInited = '1';

    var slides = Array.from(root.querySelectorAll('[data-reviews-slide]'));

    root.addEventListener('click', onPlayButtonClick);

    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;
      video.addEventListener('play', onVideoPlay);
      video.addEventListener('pause', onVideoPause);
      video.addEventListener('ended', onVideoPause);
    });

    function onPlayButtonClick(event) {
      var button = event.target.closest('[data-reviews-play]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var slide = button.closest('[data-reviews-slide]');
      var video = slide && slide.querySelector('video');
      if (!video) return;

      if (video.paused) {
        pauseAllVideos();
        video.play();
      } else {
        video.pause();
      }
    }

    function onVideoPlay(event) {
      var playedVideo = event.currentTarget;
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video && video !== playedVideo) video.pause();
      });
      var slide = playedVideo.closest('[data-reviews-slide]');
      if (slide) slide.classList.add('is-playing');
    }

    function onVideoPause(event) {
      var slide = event.currentTarget.closest('[data-reviews-slide]');
      if (slide) slide.classList.remove('is-playing');
    }

    function pauseAllVideos() {
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video) video.pause();
      });
    }

    if (root.dataset.sliderEnabled !== 'true') return;

    var outer = root.querySelector('[data-reviews-swiper]');
    if (!outer) return;

    function initSwiper() {
      if (typeof Swiper === 'undefined') return false;
      if (outer.dataset.swiperInited === '1') return true;
      outer.dataset.swiperInited = '1';

      var gap = parseInt(root.dataset.gap, 10) || 16;
      var perView = parseFloat(root.dataset.slidesDesktop) || 4.2;
      var paginationEnabled = root.dataset.paginationEnabled === 'true';
      var paginationEl = root.querySelector('[data-reviews-pagination]');

     
      new Swiper(outer, {
          loop: root.dataset.sliderLoop === 'true',
          spaceBetween: gap,
          slidesPerView: 1.4,
          centeredSlides: false,
          watchOverflow: true,
          navigation: {
            nextEl: root.querySelector('[data-reviews-next]'),
            prevEl: root.querySelector('[data-reviews-prev]'),
          },
          pagination: paginationEnabled && paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpoints: {
            600: { slidesPerView: 1.3, spaceBetween: gap, centeredSlides: false },
            750: { slidesPerView: 2.4, spaceBetween: gap, centeredSlides: false },
            990: { slidesPerView: Math.min(perView, 3.2), spaceBetween: gap, centeredSlides: false },
            1200: { slidesPerView: Math.min(perView, 4.4), spaceBetween: gap, centeredSlides: false },
            1500: { slidesPerView: perView, spaceBetween: gap, centeredSlides: false },
          },
        });

      return true;
    }

    if (!initSwiper()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (initSwiper() || tries > 40) clearInterval(timer);
      }, 100);
    }
  }

  function boot() {
    document.querySelectorAll('.reviews-proof').forEach(setupReviewsProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('.reviews-proof');
    if (root) {
      root.dataset.rpInited = '';
      setupReviewsProof(root);
    }
  });
})();